import LoadingSpinner from "@/components/Elements/LoadingSpinner.vue";
import { mapGetters } from "vuex";
import { ResourceLibraryService } from "@/services/ResourceLibraryService";
import { ErrorLogService } from "@/services/ErrorLogService";
import { controlsHelper } from "@/components/mixins/commonControlsHelper";
import { MediaService } from "@/services/";

export default {
  name: "ResourceSearchResults",
  components: { LoadingSpinner },
  mixins: [controlsHelper],
  data() {
    return {
      resources: [],
      resourceLibraryLoading: false,
    };
  },
  props: {
    searchTerm: { type: String, default: "" },
  },
  computed: {
    ...mapGetters(["user", "getContentItem", "activeAccountId", "McfCostCenterId", "audienceIds"]),
  },
  created() {
    this.fetchResources();
  },
  methods: {
    fetchResources() {
      this.resourceLibraryLoading = true;
      const params = {
        CostCenterId: this.McfCostCenterId,
        AccountId: this.activeAccountId,
        UserId: this.user?.UserId,
        UserAudiences: this.audienceIds,
        SearchTerm: this.searchTerm,
      };
      ResourceLibraryService.DocumentSearch(params)
        .then((results) => {
          this.resources = results;
        })
        .catch((err) => {
          ErrorLogService.LogException(err);
          this.resources = [];
        })
        .finally(() => {
          this.resourceLibraryLoading = false;
        });
    },
    getDownloadUrl(mediaFileId) {
      return MediaService.getMediaUrl(mediaFileId);
    },
  },
};